import { defineStore } from 'pinia'
import type { ICart } from '~/libs/types/api/cart'
import type { IResponse } from '~/libs/types/api/pagination';
import type { FetchOptions } from 'ofetch';

export const useCartStore = defineStore('cart', {
    state: () => ({
        cartItems: [] as ICart[]
    }),
    actions: {
        async refresh(options: FetchOptions = {}) {

            const defaultOptions = {
                useSanctum: true,
                params: {
                    include: 'thumb,user_price',
                }
            };

            const fetchOptions = useMerge(defaultOptions, options);

            const data: IResponse<ICart[]> = await fetchData("/cart", fetchOptions)

            if (data) {
                this.cartItems = data.data;
            }
            return data.data;
        },
        async update(id: number, body: any) {
            const data: IResponse<ICart[]> = await fetchData(`/cart/${id}/update`, {
                useSanctum: true,
                method: 'PUT',
                body,
                params: {
                    include: 'thumb'
                },
            })
        },
        async get() {
            if (!this.cartItems || this.cartItems.length === 0)
                await this.refresh();
            return this.cartItems;
        },
        async remove(id: number) {
            await fetchData(`/cart/${id}`, {
                useSanctum: true,
                method: "DELETE"
            })
            this.cartItems = useFilter(this.cartItems, (i) => i.id != id);
        }
    }
})
